module.exports = __webpack_public_path__ + "img/icon_zgl.20890e72.png";